import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../../../../../hook/services";
import { toast } from "react-toastify";

const DEFAULT_FORM = {
  id: "",
  name: "",
  link: "",
  type: "Divider",
};

const AddMenu = ({
  handleRefresh,
  data,
  editIndex = null,
  selectedButton = null,
  onClose = () => {},
}) => {
  const AppService = useAppServices();
  const { companyId, type } = useParams();
  const handler =
    type === "agency" || type === "location"
      ? AppService.sidenav_customizer_main_level
      : type === "group"
      ? AppService.sidenav_customizer_custom_level
      : AppService.sidenav_customizer_saas_level;

  const isEdit = editIndex !== null && selectedButton;
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(DEFAULT_FORM);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isEdit && selectedButton) {
      setFormData({ ...DEFAULT_FORM, ...selectedButton });
    }
  }, [isEdit, selectedButton]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    if (!isEdit) setFormData(DEFAULT_FORM);
    onClose();
  };

  const handleChange = (e) => {
    const { name, type: t, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: t === "checkbox" ? checked : value,
    }));
  };

  const setType = (newType) => {
    setFormData((prev) => ({
      ...prev,
      type: newType,
      ...(newType === "Divider" ? { link: "" } : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.warning("Name is required.");
      return;
    }
    if (formData.type === "Menu" && !formData.link.trim()) {
      toast.warning("Menu items require a link.");
      return;
    }

    const setting_menus = data?.setting_menus ? [...data.setting_menus] : [];
    if (isEdit) setting_menus[editIndex] = formData;
    else setting_menus.push(formData);

    const payload = {
      setting_menus,
      companyId,
      type,
      ...(data?._id && { _id: data._id }),
    };

    try {
      setSubmitting(true);
      const { response } = await handler[data?._id ? "update" : "create"]({
        payload,
      });

      if (response) {
        handleRefresh();
        toast.success(
          isEdit ? `${formData.type} updated!` : `${formData.type} added!`
        );
        setOpen(false);
        if (!isEdit) setFormData(DEFAULT_FORM);
        onClose();
      } else {
        toast.error(`Error saving ${formData.type}.`);
      }
    } catch (error) {
      console.error("Save setting menu error:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  const isDivider = formData.type === "Divider";

  return (
    <>
      {isEdit ? (
        <button
          className="btn d-inline-flex align-items-center justify-content-center gap-1"
          title="Edit"
          onClick={handleOpen}
          style={{
            borderRadius: 8,
            background: "#eef2ff",
            color: "#4338ca",
            border: "1px solid #c7d2fe",
            fontSize: 12,
            fontWeight: 500,
            padding: "6px 10px",
          }}
        >
          <i className="bi bi-pencil-square" />
          Edit
        </button>
      ) : (
        <button
          className="btn btn-primary d-inline-flex align-items-center gap-2"
          onClick={handleOpen}
          style={{ borderRadius: 10, fontWeight: 500 }}
        >
          <i className="bi bi-plus-lg" />
          Add Menu Item
        </button>
      )}

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(15, 23, 42, 0.55)", zIndex: 2000 }}
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
        >
          <style>{`
            .sm-modal .modal-dialog {
              max-height: calc(100vh - 3rem);
              margin-top: 1.5rem;
              margin-bottom: 1.5rem;
            }
            .sm-modal .modal-content {
              border-radius: 16px;
              overflow: hidden;
              border: none;
              box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
              max-height: calc(100vh - 3rem);
              display: flex;
              flex-direction: column;
            }
            .sm-modal form {
              display: flex;
              flex-direction: column;
              flex: 1 1 auto;
              min-height: 0;
              overflow: hidden;
            }
            .sm-modal .modal-body {
              flex: 1 1 auto;
              overflow-y: auto;
              min-height: 0;
            }
            .sm-modal .modal-body::-webkit-scrollbar { width: 8px; }
            .sm-modal .modal-body::-webkit-scrollbar-track { background: transparent; }
            .sm-modal .modal-body::-webkit-scrollbar-thumb {
              background: rgba(15, 23, 42, 0.18);
              border-radius: 8px;
            }
            .sm-modal .modal-body::-webkit-scrollbar-thumb:hover {
              background: rgba(15, 23, 42, 0.32);
            }
            .sm-modal .sm-header { flex-shrink: 0; }
            .sm-modal .sm-header {
              background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
              color: #fff;
              padding: 18px 22px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .sm-modal .sm-header h5 {
              margin: 0;
              font-weight: 600;
              font-size: 18px;
              display: flex;
              align-items: center;
              gap: 10px;
            }
            .sm-modal .sm-header small {
              color: rgba(255, 255, 255, 0.8);
              font-size: 12px;
            }
            .sm-modal .sm-close {
              background: rgba(255, 255, 255, 0.15);
              border: none;
              color: #fff;
              width: 32px;
              height: 32px;
              border-radius: 8px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              transition: background 0.15s;
            }
            .sm-modal .sm-close:hover { background: rgba(255, 255, 255, 0.28); }
            .sm-modal .sm-section-title {
              font-size: 12px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.04em;
              color: #475569;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              gap: 6px;
            }
            .sm-modal .sm-card {
              background: #fff;
              border: 1px solid #e2e8f0;
              border-radius: 12px;
              padding: 16px;
            }
            .sm-modal .sm-preview {
              background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
              border: 1px dashed #c7d2fe;
              border-radius: 12px;
              padding: 18px 22px;
              min-height: 110px;
              display: flex;
              flex-direction: column;
              align-items: stretch;
              justify-content: center;
              gap: 6px;
            }
            .sm-modal .sm-preview-label {
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.04em;
              text-transform: uppercase;
              text-align: center;
              margin-bottom: 4px;
            }
            .sm-modal .sm-preview-divider {
              position: relative;
              text-align: left;
              padding: 0 4px;
              border-bottom: 1px solid #cbd5e1;
              line-height: 0.1em;
              margin: 12px 0;
            }
            .sm-modal .sm-preview-divider span {
              background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
              color: #94a3b8;
              padding: 0 10px 0 0;
              font-size: 10px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.05em;
            }
            .sm-modal .sm-preview-link {
              padding: 8px 12px;
              border-radius: 8px;
              background: #fff;
              color: #1e293b;
              font-size: 13px;
              font-weight: 500;
              border: 1px solid #e2e8f0;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
            }
            .sm-modal .sm-preview-link .text-truncate {
              min-width: 0;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .sm-modal .sm-preview-link i {
              color: #94a3b8;
            }
            .sm-modal .form-label {
              font-size: 13px;
              font-weight: 500;
              color: #334155;
              margin-bottom: 6px;
            }
            .sm-modal .form-control,
            .sm-modal .form-select {
              border-radius: 8px;
              border-color: #e2e8f0;
              font-size: 14px;
            }
            .sm-modal .form-control:focus,
            .sm-modal .form-select:focus {
              border-color: #818cf8;
              box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
            }
            .sm-modal .type-toggle {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 10px;
            }
            .sm-modal .type-card {
              border: 1px solid #e2e8f0;
              background: #fff;
              border-radius: 10px;
              padding: 14px 12px;
              text-align: left;
              cursor: pointer;
              transition: all 0.15s;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 4px;
            }
            .sm-modal .type-card:hover { border-color: #c7d2fe; background: #f8fafc; }
            .sm-modal .type-card.active {
              background: #eef2ff;
              border-color: #4f46e5;
              box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);
            }
            .sm-modal .type-card .type-card-title {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 14px;
              font-weight: 600;
              color: #1e293b;
            }
            .sm-modal .type-card.active .type-card-title { color: #4338ca; }
            .sm-modal .type-card .type-card-help {
              font-size: 12px;
              color: #64748b;
            }
            .sm-modal .modal-footer {
              border-top: 1px solid #e2e8f0;
              padding: 14px 22px;
              background: #f8fafc;
              flex-shrink: 0;
            }
            .sm-modal .btn-cancel {
              background: transparent;
              color: #64748b;
              border: 1px solid #e2e8f0;
              border-radius: 8px;
              font-weight: 500;
            }
            .sm-modal .btn-cancel:hover { background: #f1f5f9; color: #1e293b; }
            .sm-modal .btn-save {
              background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
              border: none;
              color: #fff;
              border-radius: 8px;
              font-weight: 500;
              padding: 8px 22px;
            }
            .sm-modal .btn-save:hover { opacity: 0.92; color: #fff; }
            .sm-modal .btn-save:disabled { opacity: 0.6; }
          `}</style>

          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg sm-modal">
            <div className="modal-content">
              <div className="sm-header">
                <div>
                  <h5>
                    <i
                      className={`bi ${
                        isEdit ? "bi-pencil-square" : "bi-plus-square"
                      }`}
                    />
                    {isEdit ? "Edit Setting Menu" : "Add Setting Menu"}
                  </h5>
                  <small>
                    Add a divider header or a clickable link to the GHL
                    settings sidebar.
                  </small>
                </div>
                <button
                  type="button"
                  className="sm-close"
                  onClick={handleClose}
                  aria-label="Close"
                >
                  <i className="bi bi-x-lg" />
                </button>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="modal-body p-4">
                  {/* Live preview */}
                  <div className="sm-preview mb-4">
                    <span className="sm-preview-label">Preview</span>
                    {isDivider ? (
                      <div className="sm-preview-divider">
                        <span>{formData.name || "Section header"}</span>
                      </div>
                    ) : (
                      <div className="sm-preview-link">
                        <span className="text-truncate">
                          {formData.name || "Menu item"}
                        </span>
                        <i className="bi bi-arrow-right-short" />
                      </div>
                    )}
                  </div>

                  {/* Type */}
                  <div className="sm-card mb-3">
                    <div className="sm-section-title">
                      <i className="bi bi-collection" /> Type
                    </div>
                    <div className="type-toggle">
                      <button
                        type="button"
                        className={`type-card ${
                          formData.type === "Divider" ? "active" : ""
                        }`}
                        onClick={() => setType("Divider")}
                      >
                        <span className="type-card-title">
                          <i className="bi bi-hr" />
                          Divider
                        </span>
                        <span className="type-card-help">
                          A non-clickable section header that groups other
                          items.
                        </span>
                      </button>
                      <button
                        type="button"
                        className={`type-card ${
                          formData.type === "Menu" ? "active" : ""
                        }`}
                        onClick={() => setType("Menu")}
                      >
                        <span className="type-card-title">
                          <i className="bi bi-link-45deg" />
                          Menu link
                        </span>
                        <span className="type-card-help">
                          A clickable item that opens a URL inside settings.
                        </span>
                      </button>
                    </div>
                  </div>

                  {/* Identity */}
                  <div className="sm-card mb-3">
                    <div className="sm-section-title">
                      <i className="bi bi-tag" /> Identity
                    </div>
                    <div className="row g-3">
                      <div className="col-md-7">
                        <label className="form-label">
                          {isDivider ? "Section title" : "Menu name"}
                        </label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder={
                            isDivider ? "e.g. Custom Tools" : "e.g. Reports"
                          }
                          required
                        />
                      </div>
                      <div className="col-md-5">
                        <label className="form-label">
                          CSS id <span className="text-muted small">(unique)</span>
                        </label>
                        <input
                          type="text"
                          name="id"
                          className="form-control"
                          value={formData.id}
                          onChange={handleChange}
                          placeholder="my-section"
                        />
                      </div>
                      <div className="col-12">
                        <p className="text-muted small mb-0">
                          The id is used to render the element in GHL. Make
                          sure it doesn't collide with other ids on the page.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Link (Menu only) */}
                  {!isDivider && (
                    <div className="sm-card">
                      <div className="sm-section-title">
                        <i className="bi bi-globe" /> Destination
                      </div>
                      <label className="form-label">URL</label>
                      <input
                        type="url"
                        name="link"
                        className="form-control"
                        value={formData.link}
                        onChange={handleChange}
                        placeholder="https://..."
                        required={!isDivider}
                      />
                      <p className="text-muted small mb-0 mt-2">
                        Use <code>{"{location.id}"}</code> as a placeholder for
                        the current location id — it will be replaced at
                        runtime.
                      </p>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-cancel"
                    onClick={handleClose}
                    disabled={submitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-save"
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Saving...
                      </>
                    ) : isEdit ? (
                      `Update ${formData.type.toLowerCase()}`
                    ) : (
                      `Create ${formData.type.toLowerCase()}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddMenu;
